
export const INSTITUTIONAL_SCRIPTS = [
    {
        id: "corp-ceo-message",
        title: { pt: "Mensagem do CEO / Liderança", en: "CEO / Leadership Message", es: "Mensaje del CEO / Liderazgo" },
        tags: ["Institucional", "Liderança", "Interno"],
        content: {
            pt: `<r>SAUDAÇÃO</r>
Olá a todos da equipe [NOME DA EMPRESA].
Estou gravando este vídeo para compartilhar algumas atualizações importantes sobre o nosso trimestre.
<y>RESULTADOS</r>
Primeiro, quero parabenizar a todos pelo resultado em [PROJETO/META].
Foi um esforço coletivo incrível e os números mostram isso.
Atingimos [X]% de crescimento, o que é um recorde.
<y>DESAFIOS</r>
Sabemos que nem tudo foi fácil. Tivemos dificuldades com [PROBLEMA], mas superamos com resiliência.
<y>VISÃO DE FUTURO</r>
Para os próximos meses, nosso foco total será em [NOVA META].
Precisamos da colaboração de todos para fazer isso acontecer.
<g>ENCERRAMENTO</r>
Conto com vocês. Obrigado por todo o empenho.
Vamos juntos!`,
            en: `<r>GREETING</r>
Hello everyone from team [COMPANY NAME].
I'm recording this video to share some important updates about our quarter.
<y>RESULTS</r>
First, I want to congratulate everyone for the result in [PROJECT/GOAL].
It was an incredible collective effort and the numbers show it.
We reached [X]% growth, which is a record.
<y>CHALLENGES</r>
We know not everything was easy. We had difficulties with [PROBLEM], but we overcame with resilience.
<y>FUTURE VISION</r>
For the next months, our total focus will be on [NEW GOAL].
We need everyone's collaboration to make this happen.
<g>CLOSING</r>
I count on you. Thank you for all the effort.
Let's go together!`,
            es: `<r>SALUDO</r>
Hola a todos del equipo [NOMBRE DE LA EMPRESA].
Estoy grabando este video para compartir algunas actualizaciones importantes sobre nuestro trimestre.
<y>RESULTADOS</r>
Primero, quiero felicitar a todos por el resultado en [PROYECTO/META].
Fue un esfuerzo colectivo increíble y los números lo muestran.
Alcanzamos [X]% de crecimiento, lo que es un récord.
<y>DESAFÍOS</r>
Sabemos que no todo fue fácil. Tuvimos dificultades con [PROBLEMA], pero lo superamos con resiliencia.
<y>VISIÓN DE FUTURO</r>
Para los próximos meses, nuestro enfoque total será en [NUEVA META].
Necesitamos la colaboración de todos para hacer que esto suceda.
<g>CIERRE</r>
Cuento con ustedes. Gracias por todo el empeño.
¡Vamos juntos!`
        }
    },
    {
        id: "corp-company-values",
        title: { pt: "Visão e Valores da Empresa", en: "Company Vision and Values", es: "Visión y Valores de la Empresa" },
        tags: ["Institucional", "Cultura", "Onboarding"],
        content: {
            pt: `<r>PROPÓSITO</r>
Aqui na [EMPRESA], nós não vendemos apenas [PRODUTO].
Nós entregamos [TRANSFORMAÇÃO].
<y>VALORES FUNDAMENTAIS</r>
Nossa cultura é baseada em 3 pilares:
1. [VALOR 1]: Significa que sempre colocamos o cliente primeiro.
2. [VALOR 2]: Inovação não é opção, é obrigação.
3. [VALOR 3]: Respeito acima de tudo.
<g>O CONVITE</r>
Se você compartilha desses valores, você está no lugar certo.
Nossa missão é [MISSÃO].
Bem-vindo ao time.`,
            en: `<r>PURPOSE</r>
Here at [COMPANY], we don't just sell [PRODUCT].
We deliver [TRANSFORMATION].
<y>CORE VALUES</r>
Our culture is based on 3 pillars:
1. [VALUE 1]: Means we always put the customer first.
2. [VALUE 2]: Innovation is not an option, it's an obligation.
3. [VALUE 3]: Respect above all.
<g>THE INVITE</r>
If you share these values, you are in the right place.
Our mission is [MISSION].
Welcome to the team.`,
            es: `<r>PROPÓSITO</r>
Aquí en [EMPRESA], no vendemos solo [PRODUCTO].
Entregamos [TRANSFORMACIÓN].
<y>VALORES FUNDAMENTALES</r>
Nuestra cultura se basa en 3 pilares:
1. [VALOR 1]: Significa que siempre ponemos al cliente primero.
2. [VALOR 2]: La innovación no es opción, es obligación.
3. [VALOR 3]: Respeto ante todo.
<g>LA INVITACIÓN</r>
Si compartes estos valores, estás en el lugar correcto.
Nuestra misión es [MISIÓN].
Bienvenido al equipo.`
        }
    },
    {
        id: "corp-onboarding",
        title: { pt: "Boas-vindas para Novos Funcionários", en: "New Hire Welcome", es: "Bienvenida a Nuevos Empleados" },
        tags: ["Institucional", "RH", "Onboarding"],
        content: {
            pt: `<r>OLÁ</r>
Oi [NOME], seja muito bem-vindo à [EMPRESA].
Estamos muito felizes de ter você com a gente.
<y>POR QUE VOCÊ?</r>
Você foi escolhido entre centenas de candidatos porque vimos em você [QUALIDADE].
Acreditamos que você tem o potencial para fazer a diferença no time de [ÁREA].
<y>PRÓXIMOS PASSOS</r>
Sua primeira semana será focada em imersão.
Você vai conhecer as áreas, entender nossos processos e tomar muito café com a gente.
<g>ACESSO</r>
Seu mentor será o [NOME DO MENTOR].
Aproveite a jornada!`,
            en: `<r>HELLO</r>
Hi [NAME], welcome to [COMPANY].
We are very happy to have you with us.
<y>WHY YOU?</r>
You were chosen among hundreds of candidates because we saw [QUALITY] in you.
We believe you have the potential to make a difference in the [AREA] team.
<y>NEXT STEPS</r>
Your first week will be focused on immersion.
You will meet the departments, understand our processes and drink lots of coffee with us.
<g>ACCESS</r>
Your mentor will be [MENTOR NAME].
Enjoy the journey!`,
            es: `<r>HOLA</r>
Hola [NOMBRE], sé muy bienvenido a [EMPRESA].
Estamos muy felices de tenerte con nosotros.
<y>¿POR QUÉ TÚ?</r>
Fuiste elegido entre cientos de candidatos porque vimos en ti [CUALIDAD].
Creemos que tienes el potencial para marcar la diferencia en el equipo de [ÁREA].
<y>PRÓXIMOS PASOS</r>
Tu primera semana se centrará en la inmersión.
Conocerás las áreas, entenderás nuestros procesos y tomarás mucho café con nosotros.
<g>ACCESO</r>
Tu mentor será [NOMBRE DEL MENTOR].
¡Disfruta el viaje!`
        }
    },
    {
        id: "corp-internal-launch",
        title: { pt: "Lançamento de Produto (Interno)", en: "Product Launch (Internal)", es: "Lanzamiento de Producto (Interno)" },
        tags: ["Institucional", "Novidade", "Produto"],
        content: {
            pt: `<r>A NOVIDADE</r>
Equipe, o grande dia chegou.
Depois de meses de desenvolvimento, tenho orgulho de apresentar o [NOVO PRODUTO].
<y>O DIFERENCIAL</r>
Esse produto vai mudar o mercado porque [DIFERENCIAL].
Nossos concorrentes não têm nada parecido.
<y>ESTRATÉGIA</r>
O lançamento oficial para o público será no dia [DATA].
Nossa meta é atingir [MÉTRICA] na primeira semana.
Para isso, o time de vendas precisa focar em [ESTRATÉGIA DE VENDAS] e o marketing em [ESTRATÉGIA DE MKT].
<g>CONVOCAÇÃO</r>
Conto com a energia de todos vocês para fazer desse o maior lançamento da nossa história.`,
            en: `<r>THE NEWS</r>
Team, the big day has arrived.
After months of development, I am proud to present [NEW PRODUCT].
<y>THE DIFFERENTIATOR</r>
This product will change the market because [DIFFERENTIATOR].
Our competitors have nothing like it.
<y>STRATEGY</r>
The official public launch will be on [DATE].
Our goal is to reach [METRIC] in the first week.
For this, the sales team needs to focus on [SALES STRATEGY] and marketing on [MKT STRATEGY].
<g>SUMMONS</r>
I count on everyone's energy to make this the biggest launch in our history.`,
            es: `<r>LA NOVEDAD</r>
Equipo, el gran día ha llegado.
Después de meses de desarrollo, tengo el orgullo de presentar el [NUEVO PRODUCTO].
<y>EL DIFERENCIAL</r>
Este producto cambiará el mercado porque [DIFERENCIAL].
Nuestros competidores no tienen nada parecido.
<y>ESTRATEGIA</r>
El lanzamiento oficial al público será el día [FECHA].
Nuestra meta es alcanzar [MÉTRICA] en la primera semana.
Para eso, el equipo de ventas necesita enfocarse en [ESTRATEGIA DE VENTAS] y marketing en [ESTRATEGIA DE MKT].
<g>CONVOCATORIA</r>
Cuento con la energía de todos ustedes para hacer de este el mayor lanzamiento de nuestra historia.`
        }
    },
    {
        id: "corp-year-recap",
        title: { pt: "Recap de Fim de Ano", en: "End of Year Recap", es: "Resumen de Fin de Año" },
        tags: ["Institucional", "Celebração", "Fim de Ano"],
        content: {
            pt: `<r>REFLEXÃO</r>
Mais um ano chegando ao fim.
E que ano, hein?
Começamos com o desafio de [DESAFIO INICIAL] e terminamos com a vitória de [CONQUISTA].
<y>DESTAQUES</r>
Quero destacar 3 momentos chave:
1. O lançamento de [PROJETO].
2. A contratação de [NÚMERO] novos talentos.
3. E, claro, nossa festa de [EVENTO].
<y>AGRADECIMENTO</r>
Nada disso seria possível sem o suor de cada um de vocês.
Obrigado por vestirem a camisa.
<g>FUTURO</r>
Descansem, aproveitem a família.
Porque o ano que vem promete ser ainda maior.
Boas festas!`,
            en: `<r>REFLECTION</r>
Another year coming to an end.
And what a year, huh?
We started with the challenge of [INITIAL CHALLENGE] and ended with the victory of [ACHIEVEMENT].
<y>HIGHLIGHTS</r>
I want to highlight 3 key moments:
1. The launch of [PROJECT].
2. The hiring of [NUMBER] new talents.
3. And, of course, our [EVENT] party.
<y>GRATITUDE</r>
None of this would be possible without the sweat of each one of you.
Thank you for wearing the shirt.
<g>FUTURE</r>
Rest, enjoy your family.
Because next year promises to be even bigger.
Happy holidays!`,
            es: `<r>REFLEXIÓN</r>
Otro año llegando a su fin.
Y qué año, ¿eh?
Empezamos con el desafío de [DESAFÍO INICIAL] y terminamos con la victoria de [LOGRO].
<y>DESTACADOS</r>
Quiero destacar 3 momentos clave:
1. El lanzamiento de [PROYECTO].
2. La contratación de [NÚMERO] nuevos talentos.
3. Y, claro, nuestra fiesta de [EVENTO].
<y>AGRADECIMIENTO</r>
Nada de esto sería posible sin el sudor de cada uno de ustedes.
Gracias por ponerse la camiseta.
<g>FUTURO</r>
Descansen, disfruten a la familia.
Porque el año que viene promete ser aún mayor.
¡Felices fiestas!`
        }
    }
];
